import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import { Note } from '../../../../../../../components/note/note';
import FedexV2CredentialsStore from '../../../../stores/credentials/shipping/fedex-v2/fedex-v2-credentials-store';
import FedexV2RegistrationModal from './fedex-v2-registration-modal';

interface IProps {
    credentialsStore: FedexV2CredentialsStore;
    vGroup: IValidationGroup;
}

const FedexV2Credentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {
    useEffect(() => {
        vGroup.update({
            id: 'fedex-v2-registration',
            isValid: true,
        });

        return () => vGroup.delete('fedex-v2-registration');
    }, [vGroup]);

    return (
        <>
            <Note body="Connect your FedEx account using the official Account Registration flow with MFA." />
            <FedexV2RegistrationModal credentialsStore={credentialsStore} />
        </>
    );
});

export default FedexV2Credentials;
